import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
/* Layout */
// import Layout from '@/layout'
import Wrapper from "@/wrapper";

/* Router Modules */
import vehicleInsuranceRouter from "./modules/vehicle-insurance";
import resultPage from "./modules/result-page";

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index")
  },
  {
    path: "/ChangePhone",
    component: () => import("@/views/login/ChangePhone")
  },
  {
    path: "/404",
    component: () => import("@/views/error-page/404")
  },
  {
    path: "/401",
    component: () => import("@/views/error-page/401")
  },
  {
    path: "/",
    component: () => import("@/views/personal-center/index"),
    name: "Personal-Center",
    meta: {
      title: "个人中心",
    }
  },
  {
    path: "/share-list",
    component: () => import("@/views/shared-parking/shareorder"),
    name: "Share-List",
    meta: {
      title: "共享停车"
    }
  }, {
    path: "/feedback",
    component: () => import("@/views/feedback/index"),
    name: "Feedback",
    meta: {
      title: "问题反馈"
    }
  },
  // {
  //   path: "/epidemic-map",
  //   component: () => import("@/views/epidemic-map/index"),
  //   name: "Epidemic-Map",
  //   meta: {
  //     title: "患者轨迹",
  //   }
  // },
  {
    path: "/my-car",
    component: () => import("@/views/my-car/index"),
    name: "My-Car",
    meta: {
      title: "我的车辆"
    }
  },
  {
    path: "/parking-assistant",
    component: () => import("@/views/parking-assistant/index"),
    name: "Parking-Assistant",
    meta: {
      title: "停车助手"
    }
  },
  {
    path: "/bind-car",
    component: () => import("@/views/bind-car/index"),
    name: "BindCar",
    meta: {
      title: "绑定车牌"
    }
  },
  {
    path: "/pay-parking-cost",
    component: () => import("@/views/pay-parking-cost/index"),
    name: "Pay-Parking-Cost",
    meta: {
      title: "停车缴费",
    }
  },
  {
    path: "/reserve-parking",
    component: () => import("@/views/reserve-parking/home"),
    name: "Reserve-Parking",
    meta: {
      title: "预约停车",
    }
  },
  {
    path: "/reserve-parking-list",
    component: () => import("@/views/reserve-parking/index"),
    name: "Reserve-Parking-List",
    meta: {
      title: "预约停车",
    }
  },
  {
    path: "/reserve-pay",
    component: () => import("@/views/reserve-parking/reserve-pay"),
    name: "Reserve-Pay",
    meta: {
      title: "预约停车",
    }
  },
  {
    path: "/reserve-list",
    component: () => import("@/views/reserve-parking/reserve-list"),
    name: "Reserve-List",
    meta: {
      title: "预约停车",
    }
  },
  {
    path: "/reserve-result",
    component: () => import("@/views/reserve-parking/result"),
    name: "Reserve-Result",
    meta: {
      title: "预约停车",
    }
  },
  {
    path: "/credit-score",
    component: () => import("@/views/credit-score/index"),
    name: "Credit-Score",
    meta: {
      title: "信用积分",
    }
  },
  {
    path: "/business",
    component: () => import("@/views/business/index"),
    name: "Business",
    meta: {
      title: "商务合作",
    }
  },
  {
    path: "/month-card",
    component: () => import("@/views/month-card/index"),
    name: "month-card",
    meta: {
      title: "月卡管理",
    }
  },
  {
    path: "/card-pay",
    component: () => import("@/views/month-card/cardpay"),
    name: "card-pay",
    meta: {
      title: "月卡充值",
    }
  },
  {
    path: "/pay-parking-deposit",
    component: () => import("@/views/pay-parking-deposit/index"),
    name: "Pay-Parking-Cost",
    meta: {
      title: "充值押金"
    }
  },
  {
    path: "/parking-reservation",
    component: () => import("@/views/parking-reservation/index"),
    name: "Parking-Reservation",
    meta: {
      title: "车位预约"
    }
  },
  {
    path: "/order-list",
    component: () => import("@/views/order-list/index"),
    name: "Order-List",
    meta: {
      title: "缴费记录"
    }
  },
  {
    path: "/my-order",
    component: () => import("@/views/my-order/index"),
    name: "My-Order",
    meta: {
      title: "我要缴费"
    }
  },
  {
    path: "/temporary-parking-cost",
    component: () => import("@/views/temporary-parking-cost/index"),
    name: "Temporary-Parking-Cost",
    meta: {
      title: "临停缴费",
    }
  },
  {
    path: "/temporary-parking-cost-doorway",
    component: () => import("@/views/temporary-parking-cost-doorway/index"),
    name: "Temporary-Parking-Cost-Doorway",
    meta: {
      title: "出口缴费",
      PL: true
    }
  },
  {
    path: "/wallet",
    component: () => import("@/views/wallet/index"),
    name: "Wallet",
    meta: {
      title: "我的钱包"
    }
  },
  {
    path: "/jn-pay-result",
    component: () => import("@/views/jn-pay-result/index"),
    name: "JnPayResult",
    meta: {
      title: ""
    }
  },
  {
    path: "/reservation-result",
    component: () => import("@/views/reservation-result/index"),
    name: "ReservationResult",
    meta: {
      title: "预约结果"
    }
  },
  {
    path: "/certificates",
    component: () => import("@/views/certificates/index"),
    name: "Certificates",
    meta: {
      title: "上传证件"
    }
  },
  {
    path: "/customer-service",
    component: () => import("@/views/customer-service/index"),
    name: "CustomerService",
    meta: {
      title: "客服帮助"
    }
  },
  {
    path: "/unlicensed",
    component: () => import("@/views/unlicensed/index"),
    name: "Unlicensed",
    meta: {
      title: "无牌车入场"
    }
  },


  {
    path: "/invoice",
    component: Wrapper,
    redirect: "/invoice/invoice-home",
    children: [
      // 发票主页
      {
        path: "invoice-home",
        component: () => import("@/views/invoice/home"),
        name: "Invoice-Home",
        meta: {
          title: "电子发票"
        }
      },
      {
        path: "invoice-temporary",
        component: () => import("@/views/invoice/invoice-temporary/index"),
        name: "Invoice-Temporary",
        meta: {
          title: "临停订单"
        }
      },
      {
        path: "invoice-month",
        component: () => import("@/views/invoice/invoice-month/index"),
        name: "Invoice-Month",
        meta: {
          title: "包月订单"
        }
      },
      {
        path: "invoice-history",
        name: "Invoice-History",
        component: () => import("@/views/invoice/invoice-history/index"),
        meta: {
          title: "开票历史"
        }
      },
      {
        path: "invoice-help",
        name: "Invoice-Help",
        component: () => import("@/views/invoice/invoice-help/index"),
        meta: {
          title: "发票帮助"
        }
      },
      {
        path: "invoice-form",
        name: "Invoice-Form",
        component: () => import("@/views/invoice/invoice-form/index"),
        meta: {
          title: "开具发票"
        }
      },
      {
        path: "invoice-again",
        name: "Invoice-Again",
        component: () => import("@/views/invoice/invoice-again/index"),
        meta: {
          title: "重新开票"
        }
      },
      {
        path: "invoice-result",
        name: "Invoice-Result",
        component: () => import("@/views/invoice/invoice-result/index"),
        meta: {
          title: "开具结果"
        }
      }
    ]
  },
  {
    path: "/arrears-bill",
    component: Wrapper,
    redirect: "/arrears-bill/index",
    children: [
      // 欠费补缴主页
      {
        path: "index",
        component: () => import("@/views/arrears-bill/index"),
        name: "Arrears-Bill-Index",
        meta: {
          title: "欠费补缴"
        }
      },
      {
        path: "arrears-bill-temporary",
        component: () =>
          import("@/views/arrears-bill/arrears-bill-temporary/index"),
        name: "Arrears-Bill-Temporary",
        meta: {
          title: "欠费订单",
        }
      },
      {
        path: "arrears-confirm-order",
        component: () =>
          import("@/views/arrears-bill/arrears-confirm-order/index"),
        name: "Arrears-Bill-Order",
        meta: {
          title: "确认缴费"
        }
      },
      {
        path: "arrears-bill-help",
        component: () => import("@/views/arrears-bill/arrears-bill-help/index"),
        name: "Arrears-Bill-Help",
        meta: {
          title: "补缴帮助"
        }
      }
    ]
  },
  {
    path: "/setting",
    component: Wrapper,
    redirect: "/setting-center/setting-home",
    children: [
      // 设置主页
      {
        path: "setting-home",
        component: () => import("@/views/setting-center/home"),
        name: "Setting-Home",
        meta: {
          title: "设置"
        }
      },
      {
        path: "setting-self",
        component: () => import("@/views/setting-center/setting-self/index"),
        name: "Setting-Self",
        meta: {
          title: "个人信息"
        }
      },
      {
        path: "setting-safe",
        component: () => import("@/views/setting-center/setting-safe/index"),
        name: "Setting-Safe",
        meta: {
          title: "安全设置"
        }
      }
    ]
  },
  /** when your routing map is too long, you can split it into small modules **/
  vehicleInsuranceRouter,
  resultPage,
  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/404" }
];

const createRouter = () =>
  new Router({
    mode: "history", // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter () {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
